import React from 'react'

interface ThemeContextType {
  light: Record<string, any>,
  dark: Record<string, any>,
  colorMode: string,
  setColorMode: () => void,
  toggleColorMode: () => void,
}

export const ThemeContext = React.createContext<ThemeContextType>({
  light: {},
  dark: {},
  colorMode: 'dark',
  setColorMode: () => {},
  toggleColorMode: () => {},
})
